import styles from './SortIcons.module.less'
import { FaSortDown, FaSortUp } from 'react-icons/fa'
import React from 'react'

const SortIcons = ({ ascending }: { ascending: boolean }) => (
  <span className={styles.sortIcons}>
    <FaSortUp className={ascending ? styles.dark : styles.light} size={20} />
    <FaSortDown className={ascending ? styles.light : styles.dark} size={20} />
  </span>
)

export default SortIcons
